import { TrendingUp } from 'lucide-react';

import type {
  FundTransactionDetail,
  ReconciliationStateResponse,
} from '@/types/fund-transactions';

import { renderFields, resolveEyebrow, toView } from './assetSaleDetails';
import { TransactionDetailsCard } from './TransactionDetailsCard';

export function AssetSaleDetailsCard({
  transaction,
  fundName,
  reconciliation,
  onViewJournalEntries,
}: {
  transaction: FundTransactionDetail;
  fundName: string;
  reconciliation: ReconciliationStateResponse | undefined;
  onViewJournalEntries?: () => void;
}) {
  const view = toView(transaction.asset_sale);
  const companyHref =
    view?.portfolioCompanyId && transaction.captable_transaction_id
      ? `/app/portfolio/${view.portfolioCompanyId}/asset-transactions/${transaction.captable_transaction_id}`
      : null;

  return (
    <TransactionDetailsCard
      transaction={transaction}
      fundName={fundName}
      reconciliation={reconciliation}
      onViewJournalEntries={onViewJournalEntries}
      icon={<TrendingUp className="h-5 w-5" />}
      iconClassName="bg-cyan-100 text-cyan-600 dark:bg-cyan-950/40 dark:text-cyan-300"
      eyebrow={resolveEyebrow(view)}
      fields={renderFields(view, transaction.currency, companyHref)}
    />
  );
}
